/* PB VIDEO STEPS v3 (PB-1180, src M-8EBC), for sections/pb-video-steps.liquid.
   1. Steps, one at a time: the scene is held (position:sticky) on a tall track. Scroll progress through the track is
      split into one slice per step. In its slice a step is "now": its title and text fill in word by word over the
      first 80% of the slice, then it holds full while you read. Steps before it stay fully lit, steps after it stay dim.
      Scrolled back, it empties again. Class changes only, one rAF per scroll; height-only resizes (the iPhone toolbar)
      are ignored.
   2. Video, quick start: one progressive MP4 with a poster. About two and a half screens before the block arrives it starts
      buffering (preload auto; the 480p rendition when it is shown under ~300 device pixels wide), it starts playing
      muted and inline about half a screen before it scrolls into view, so it is already moving when seen, and pauses when it leaves. Reduced motion: no autoplay, the
      video keeps its controls and every step shows in full (nothing is held). Adds no page-level state. */
(function () {
  if (window.__pbvsBoot) { window.__pbvsBoot(); return; }
  var RM = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  function cl(v) { return v < 0 ? 0 : v > 1 ? 1 : v; }

  function video(root) {
    var v = root.querySelector('[data-video]');
    if (!v || RM || !('IntersectionObserver' in window)) return;
    v.removeAttribute('controls');
    v.muted = true; v.setAttribute('muted', '');
    var small = v.getAttribute('data-src-s'), fb = v.getAttribute('data-src-fb');
    var primed = false, inView = false;
    v.addEventListener('error', function () {          /* a lighter rendition failed: use the full-size file */
      if (fb && v.currentSrc.indexOf(fb.replace(/^https?:/, '')) < 0) { v.src = fb; try { v.load(); } catch (e) {} if (inView) v.play().catch(function () {}); }
    }, true);
    function prime() {
      if (primed) return; primed = true;
      var w = (v.getBoundingClientRect().width || 200) * (window.devicePixelRatio || 1);
      if (small && w <= 300 && v.currentSrc.indexOf(small) < 0) v.src = small;
      v.preload = 'auto';
      try { v.load(); } catch (e) {}
    }
    new IntersectionObserver(function (es) { if (es[0].isIntersecting) prime(); }, { rootMargin: '250% 0px 250% 0px' }).observe(v);   /* buffer from about 2.5 screens away */
    new IntersectionObserver(function (es) {
      inView = es[0].isIntersecting;
      if (inView) {
        prime();
        var p = v.play(); if (p && p.catch) p.catch(function () { v.setAttribute('controls', ''); });
      } else if (!v.paused) v.pause();
    }, { rootMargin: '60% 0px 60% 0px', threshold: 0 }).observe(v);   /* starts about half a screen early (iPhone Safari only buffers once it plays), so it is already moving when seen */
  }

  function steps(root) {
    if (RM) return;
    var track = root.querySelector('[data-track]'), scene = root.querySelector('[data-scene]');
    var els = [].slice.call(root.querySelectorAll('[data-step]'));
    if (!track || !scene || !els.length) return;
    root.classList.add('is-live');
    var S = els.map(function (el) { return { el: el, w: [].slice.call(el.querySelectorAll('.pbvs__w')), n: -1, on: null, now: null }; });
    var N = S.length, vw = innerWidth, vh = innerHeight, raf = false, near = false, total = 1;
    function measure() { total = Math.max(1, track.offsetHeight - scene.offsetHeight); }
    function frame() {
      raf = false;
      var p = cl(-track.getBoundingClientRect().top / total) * N;
      var cur = Math.min(N - 1, Math.floor(p));
      for (var i = 0; i < N; i++) {
        var s = S[i], f = i < cur ? 1 : i > cur ? 0 : cl((p - i) / 0.8);
        var n = Math.round(f * s.w.length);
        if (n !== s.n) {
          for (var j = 0; j < s.w.length; j++) {
            var want = j < n;
            if (want !== (s.w[j].__in === true)) { s.w[j].__in = want; s.w[j].classList.toggle('is-in', want); }
          }
          s.n = n;
        }
        var on = i <= cur, now = i === cur;
        if (on !== s.on) { s.on = on; s.el.classList.toggle('is-on', on); }
        if (now !== s.now) { s.now = now; s.el.classList.toggle('is-now', now); }
      }
      root._pbvsP = p;
    }
    function kick() { if (!raf) { raf = true; requestAnimationFrame(frame); } }
    measure(); frame();
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { near = es[0].isIntersecting; if (near) kick(); }, { rootMargin: '30% 0px 30% 0px' }).observe(track);
    } else near = true;
    addEventListener('scroll', function () { if (near) kick(); }, { passive: true });
    addEventListener('resize', function () {
      if (innerWidth === vw && Math.abs(innerHeight - vh) <= 150) return;
      vw = innerWidth; vh = innerHeight; measure(); kick();
    }, { passive: true });
    addEventListener('load', function () { measure(); kick(); });
  }

  function boot(root) {
    if (root.__pbvs) return;
    root.__pbvs = 1;
    video(root);
    steps(root);
  }
  function bootAll() { [].forEach.call(document.querySelectorAll('[data-pbvs]'), boot); }
  window.__pbvsBoot = bootAll;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bootAll); else bootAll();
  document.addEventListener('shopify:section:load', bootAll);
})();
